import { CREATE_BOOKING, CREATE_BOOKING_END, CREATE_BOOKING_INIT } from "../constants/create-booking";

export function createBooking(
  userId: number,
  practiceId: number | string,
  timeslotId: number,
  assistantNote: string,
  officeId: number | string
) {
  return {
    type: CREATE_BOOKING,
    api: true,
    payload: {
      method: "POST",
      url: "bookings",
      data: { userId, practiceId, timeslotId, assistantNote },
    },
    data: { officeId },
  };
}

export function createBookingInit() {
  return {
    type: CREATE_BOOKING_INIT,
  };
}

export function createBookingEnd() {
  return {
    type: CREATE_BOOKING_END,
  };
}
